<template>
<div class="container">
    <div class="regist-header">
    <h1>독도 지킴이 신청</h1>
    </div>
    <div class="regist">
        <div v-if="user_image == ''" class="regist-default-img"></div>
        <div v-else class="regist-change-img" v-bind:style="{ 'background-image': 'url(' + user_image + ')' }"></div>
        <div class="file">
        <label class="file-label">
            <input class="file-input" type="file" @change="processFile($event)" accept="image/*;capture=camera">
            <span class="file-cta"></span>
        </label>
        </div>
    </div>
    <div class ="form-box">
    <div class="regist-flex">
    <span class="regist-label">이름 :</span>
    <input type="text" v-model="user_name" class="inputregist" placeholder="필명을 입력해주세요" />
    </div>
    <div class="regist-flex">
    <span class="regist-label">이메일 :</span>
    <input type="email" v-model="user_email" class="inputregist" placeholder="이메일을 입력해주세요" />
    </div>
    <div class="regist-flex">
        <span class="select-label">나이 :</span>
        <div class="select">
            <select class="selectregist" v-model="user_age" >
                <option disabled value="" >Select Age</option>
                <option>선택 안함</option>
                <option>10대(10s)</option>
                <option>20대(20s)</option>
                <option>30대(30s)</option>
                <option>40대(40s)</option>
                <option>50대(50s)</option>
                <option>60대(60s)</option>
            </select>
        </div>
    </div>
    </div>
    <router-link to="/beforetuto" v-if="user_email != '' && user_name != '' && user_age != ''" class="linkbtn" @click.native.prevent="sendUserinfo">확인</router-link>
    <router-link to="/register" v-else class="nullbtn" >확인</router-link>
</div>
</template>

<script>
/* eslint-disable */
import mypage from './mypage'
export default {
    components : {
        mypage,
    },
    computed: {
        user_name: {
            get () {
                return this.$store.state.user_name
            },
            set (value) {
                console.log(value)
                this.$store.commit('SetUsername', value)
            }
        },
        user_email: {
            get () {
                return this.$store.state.user_email
            },
            set (value) {
                console.log(value)
                this.$store.commit('SetUseremail', value)
            }
        },
        user_age: {
            get () {
                return this.$store.state.user_age
            },
            set (value) {
                console.log(value)
                this.$store.commit('SetUserage', value)
            }
        },
        user_image: {
            get () {
                return this.$store.state.user_image
            },
            set (value) {
                console.log(value)
                this.$store.commit('SetUserimg', value)
            }
        },
    },
    methods: {
    processFile(event) {
        const file = event.target.files[0]
        this.user_image = URL.createObjectURL(file);
    },
    sendUserinfo(event){
        //console.log("senduserinfo call")
        this.$store.dispatch('sendUserinfo')
    }
}

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/register.vue